import OBase from './OBase';

import * as Geometry from '../geometry';
import { GHPlane } from '../../math';

export default class Move extends OBase {
  update () {
    let transTree = this.getVector3Input('Motion', false);
    let geomInputTree = this.getObjectInput('Geometry');

    let output = this.outputs['Geometry'].paramObject;

    let dataTrees = [transTree, geomInputTree];
    let outDataTrees = [];

    Geometry.makeMultiplePairs(dataTrees, outDataTrees);

    let outTree = new Geometry.DataTree();

    let n0 = outDataTrees[0].branches.length;
    let n1 = outDataTrees[1].branches.length;

    if (n0 > 0 && n1 > 0) {
      for (let i = 0; i < outDataTrees[0].branches.length; i++) {

        if(outDataTrees[0].branches[i].length == 0)
        {
          outTree.addEmpty(outDataTrees[0].paths[i]);
          continue;
        }

        for (let j = 0; j < outDataTrees[0].branches[i].length; j++) {
          let trans = outDataTrees[0].branches[i][j];
          let geomInput = outDataTrees[1].branches[i][j];
          if(geomInput == null) continue;

          if (geomInput instanceof THREE.Geometry) {
            let mat = new THREE.Matrix4();
            mat.identity();
            mat.setPosition(trans);
            let g = geomInput.clone();
            g.applyMatrix(mat);
            outTree.add(g, outDataTrees[0].paths[i]);
          } else if (geomInput instanceof THREE.Vector3) {
            let ret = geomInput.clone().add(new THREE.Vector3(trans.x, trans.y, trans.z));
            outTree.add(ret, outDataTrees[0].paths[i]);
            // global.debugger.addPoints([new THREE.Vector3(ret.x, ret.y, ret.z)])
          } else if (geomInput instanceof GHPlane) {
            let ret = geomInput.clone();
            ret.translate(trans);
            outTree.add(ret, outDataTrees[0].paths[i]);
          } else {
            let paths = geomInput;

            let movedPaths = [];
            for (let k = 0; k < paths.length; k++) {
              let path = paths[k];
              movedPaths.push([]);
              for (let t = 0; t < path.length; t++) {
                let pt = path[t];
                let moved = new ClipperLib.DoublePoint(pt.X + trans.x, pt.Y + trans.y);
                movedPaths[k].push(moved);
              }
            }

            outTree.add(movedPaths, outDataTrees[0].paths[i]);
          }
        }
      }
    }

    output.value = outTree;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/Move.js